import React, { useState } from "react";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CFormSelect,
  CTab,
  CTabContent,
  CTabList,
  CTabPanel,
  CTabs,
} from "@coreui/react";

import PersonWorkloadHeatmap, { CURRENT_YEAR, YEAR_OPTIONS } from "./PersonWorkloadHeatmap";

const PersonWorkloadHeatmapTabs = ({ clientId, showNoIncentiveTab }) => {
  const [year, setYear] = useState(CURRENT_YEAR);
  const [activeTab, setActiveTab] = useState(
    showNoIncentiveTab ? "no_incentive" : "incentive"
  );

  return (
    <CCard className="mb-3">
      <CCardHeader className="d-flex justify-content-between align-items-center">
        <strong>Carga de Trabalho por Pessoa</strong>
        <CFormSelect
          style={{ width: "auto" }}
          value={year}
          onChange={(e) => setYear(Number(e.target.value))}
        >
          {YEAR_OPTIONS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </CFormSelect>
      </CCardHeader>
      <CCardBody>
        <CTabs activeItemKey={activeTab} onChange={setActiveTab}>
          <CTabList variant="tabs" className="mb-3">
            {showNoIncentiveTab && (
              <CTab itemKey="no_incentive">Sem Incentivo</CTab>
            )}
            <CTab itemKey="incentive">Com Incentivo</CTab>
            <CTab itemKey="all">Todos os Projetos</CTab>
          </CTabList>
          <CTabContent>
            {showNoIncentiveTab && (
              <CTabPanel itemKey="no_incentive">
                {activeTab === "no_incentive" && (
                  <PersonWorkloadHeatmap
                    clientId={clientId}
                    noIncentive={true}
                    year={year}
                  />
                )}
              </CTabPanel>
            )}
            <CTabPanel itemKey="incentive">
              {activeTab === "incentive" && (
                <PersonWorkloadHeatmap
                  clientId={clientId}
                  noIncentive={false}
                  year={year}
                />
              )}
            </CTabPanel>
            <CTabPanel itemKey="all">
              {activeTab === "all" && (
                <PersonWorkloadHeatmap clientId={clientId} year={year} />
              )}
            </CTabPanel>
          </CTabContent>
        </CTabs>
      </CCardBody>
    </CCard>
  );
};

export default PersonWorkloadHeatmapTabs;
